import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './components/HomePage.vue'
import TeleOperation from './components/TeleOperation.vue'
import CameraStreaming from './components/CameraStreaming.vue'
import MobileManipulator from './components/MobileManipulator.vue'
import ManipulationBots from './components/ManipulationBots.vue'
import FightingBots from './components/FightingBots.vue'
import CameraSpectator from './components/CameraSpectator.vue'
import BotsManager from './components/BotsManager.vue'
import BotTest from './components/BotTest.vue'

const routes = [
  { path: '/', component: HomePage },
  { path: '/teleop/:session', component: TeleOperation, meta: { hideSideNav: true }, },
  { path: '/camera_streaming', component: CameraStreaming, meta: { requiresAuth: true } },
  { path: '/mobile_manipulator', component: MobileManipulator, meta: { requiresAuth: true } },
  { path: '/manipulation', component: ManipulationBots, meta: { requiresAuth: true } },
  { path: '/ufb', component: FightingBots, meta: { requiresAuth: true } },
  { path: '/spectator', component: CameraSpectator, meta: { requiresAuth: true } },
  { path: '/manager', component: BotsManager, meta: { requiresAuth: true } },
  { path: '/bot_test', component: BotTest, meta: { requiresAuth: true } }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
